import {createSelector} from "@ngrx/store";
import {IAppState} from "../../state/app.state";
import {IAccountingState} from "../../state/accounting/accounting.state";

export const selectAccounts = createSelector(
  (state: IAppState) => state.accounting,
  (state:IAccountingState) => state
);

